import * as types from 'models/actionTypes'

export const showToast = (toastType, props) => ({
    type: types.SHOW_TOAST,
    toastType,
    props,
})

export const hideToast = (index) => ({
    type: types.HIDE_TOAST,
    index,
})
